/**
 * Portal ICAVI - Serviço de domínio: Perfis e Permissões
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const perfisServiceMethods = {
    /**
     * Busca lista de perfis
     */
    async getPerfis() {
        try {
            const response = await api.get('/api/perfis');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar perfis:', error);
            throw error;
        }
    },
    /**
     * Busca perfil por ID
     */
    async getPerfil(perfilId) {
        try {
            const response = await api.get(`/api/perfis/${perfilId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar perfil:', error);
            throw error;
        }
    },
    /**
     * Cria novo perfil
     */
    async createPerfil(perfil) {
        try {
            const response = await api.post('/api/perfis', perfil);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao criar perfil:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Atualiza perfil existente
     */
    async updatePerfil(perfilId, perfil) {
        try {
            const response = await api.put(`/api/perfis/${perfilId}`, perfil);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar perfil:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Exclui perfil
     */
    async deletePerfil(perfilId) {
        try {
            const response = await api.delete(`/api/perfis/${perfilId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir perfil:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Busca lista de permissões
     */
    async getPermissoes() {
        try {
            const response = await api.get('/api/permissoes');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar permissões:', error);
            throw error;
        }
    },
    /**
     * Busca templates de perfis
     */
    async getTemplatesPerfis() {
        try {
            const response = await api.get('/api/perfis/templates');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar templates de perfis:', error);
            throw error;
        }
    },
    /**
     * Cria perfil a partir de template
     */
    async createPerfilFromTemplate(templateId, dadosPersonalizados = {}) {
        try {
            const response = await api.post(`/api/perfis/templates/${templateId}`, dadosPersonalizados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao criar perfil a partir de template:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
